export default "__VITE_ASSET__B6XUNPOD__"